export default __webpack_public_path__ + "static/media/Kuda-Bank.3e811ec3.png";